rs.module("controls/indicators/skeleton",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        //
        // Initialize the skeleton
        //
        function initialize(_skeletonSelector, clientTemplateKey, delayBy) {

            delayBy = delayBy || 0;

            setTimeout(function () {

                // Get the skeleton - not required b\c it could be that after the delay there is already real content
                var skeleton = $.js(_skeletonSelector, { required: false });

                if (skeleton.exists()) {

                    // Extract the content from the client template and add to the container
                    var content = $(clientTemplates.render(clientTemplateKey));
                    skeleton.append(content);

                    // Get the visible background color (what the user is actually seeing)
                    var backgroundColor = addTransparency(skeleton.visibleBackgroundColor(), 0.6);

                    // Apply that to the motion wave, and turn off the loading indicator
                    content.removeClass("_loading");
                    content.attr("style", `--background:${backgroundColor};--duration:1.5s;`);
                }

            }, delayBy);
        }

        //
        // Add the given amount of transparency to the color
        //
        function addTransparency(color, amount) {

            // TEMP: Until we convert to browserify and can use Color.js
            return color.replace("rgb", "rgba").replace(")", `, ${amount})`);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);